import React, { useState } from 'react'
// import { Col, Row } from 'react-bootstrap'
// import { Link } from 'react-router-dom'
import Formvalidators from '../validators/Formvalidators'
import { Link, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'

export default function SignUp() {
  let [data , setData] = useState({
    name:"",
    username:"",
    email:"",
    phone:"",
    password:"",
    cpassword:""
  })

  let navigate = useNavigate()
  let [show , setShow] = useState(false)
  let [errorMessage , setErrorMessage] = useState({
       name :"Name is Required",
       username :"Name is Required",
       email :"Email is Required",
       phone :"Phone is Required",
       password :"Password is Required",
       cpassword :"Confirm Password is Required",
       
  })

  function getInputData(e) {
    var { name, value } = e.target;
    
    setErrorMessage((old) => {
      return {
        ...old,
        [name]: Formvalidators(e),
      };
    });

    setData((old) => {
      return {
        ...old,
        [name]: value,
      };
    });
  }

  async function postData(e) {
    e.preventDefault();
    if (data.password === data.cpassword) {
      let error = Object.values(errorMessage).find((x) => x !== "");
      if (!error) {
        let resposne = await fetch("http://34.228.14.188:8000/api/user", {
          method: "GET",
          headers: {
            "content-type": "application/json",
          },
        });
        resposne = await resposne.json();
        let item = resposne.data.find((x) => x.username === data.username || x.email === data.email);
      
        
        if (item) {
          setShow(true);
          setErrorMessage((old) => {
            return {
              ...old,
              username:
                item.username === data.username ? "Username Already Taken" : "",
              email:
                item.email === data.email ? "Email Address Already Taken" : "",
            };
          });
        } else {
          item = {
            name: data.name,
            username: data.username,
            email: data.email,
            phone: data.phone,
            password: data.password,
            role: "@u_%&@!==?*&@!",
          };
          resposne = await fetch("http://34.228.14.188:8000/api/user", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              // "authorization": localStorage.getItem("token")
            },
            body:JSON.stringify(item),
          });
          resposne = await resposne.json();
          if (resposne) navigate("/signin");
          else alert("Something Went Wrong");
        }
      } else setShow(true);
    } else {
      setErrorMessage((old) => {
        return {
          ...old,
          ["password"]: "Password and Confirm Password Doesn't Matched",
        };
      });
      setShow(true);
    }
  }

  return (
    <>
      <Helmet>
  <title>Sign Up | V Hotel The Grand Shoba</title>
  <meta name="description" content="Create a new account at V Hotel The Grand Shoba to manage your bookings, view special offers, and more." />
  <meta name="robots" content="noindex, nofollow" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  </Helmet>
  

    <div className="signup-container ">
      <div className="left-side">
        <div className="welcome-box">
          <img src="/images/create-img.svg" alt="V_Hotel_the_Grand_shoba_Logo" title='V_hotel_the_grand_shoba' />
          <div className="welcome-box-details">
         < h3>Welcome to</h3>
          <h2>V The Grand Shoba</h2>
          <p>Discover and Find Your <span>Best</span> Stay Place in Delhi</p>
          </div>
        </div>
      </div>

      <div className="right-side">
        <div className="form-box">
          <h3>Create Your Account</h3>
          <form onSubmit={postData}>
            <label>Name*</label>
            <input type="text" onChange={getInputData} className={`${show && errorMessage?"border-danger":""}`} name='name' placeholder="Enter Your Name" />
            {show && errorMessage.name ? (
                    <p className="text-danger">{errorMessage.name}</p>
                  ) : (
                    ""
                  )}
                    <label>User Name*</label>
            <input type="text" onChange={getInputData} className={`${show && errorMessage?"border-danger":""}`} name='username' placeholder="Enter Your UserName" />
            {show && errorMessage.username ? (
                    <p className="text-danger">{errorMessage.username}</p>
                  ) : (
                    ""
                  )}
            <label>Email Address*</label>
            <input type="email" name="email" onChange={getInputData} className={`${show && errorMessage?"border-danger":""}`} id="" placeholder='Enter Your Email' />
            {show && errorMessage.email ? (
                    <p className="text-danger">{errorMessage.email}</p>
                  ) : (
                    ""
                  )}
            <label>Phone*</label>
            <input type="text" name="phone" id="" onChange={getInputData} className={`${show && errorMessage?"border-danger":""}`} placeholder='Enter Your Phone'/>
            {show && errorMessage.phone ? (
                    <p className="text-danger">{errorMessage.phone}</p>
                  ) : (
                    ""
                  )}
            
            <label>Password*</label>
            <input type="password" onChange={getInputData}  className={`${show && errorMessage?"border-danger":""}`} name='password' placeholder="Enter Your Password" />
            {show && errorMessage.password ? (
                    <p className="text-danger">{errorMessage.password}</p>
                  ) : (
                    ""
                  )}
            <label>Re-Password*</label>
            <input type="password" onChange={getInputData} className={`${show && errorMessage?"border-danger":""}`} name='cpassword' placeholder="Enter Your Password" />
            {show && errorMessage.cpassword ? (
                    <p className="text-danger">{errorMessage.cpassword}</p>
                  ) : (
                    ""
                  )}
            

            <div className="btn-group">
              <button type="submit" className="btn-primary w-100">Sign up</button>
               <Link to="/signin">  <button type="button"  className="btn-secondary">Sign In</button></Link>  
            </div>
          </form>
          <div className="other-login">
                <hr /><span>OR</span> <hr />
                
              </div>
           <p className="mt-3 text-center">
                        Already have an account? <Link to="/signin">Login</Link>
                        </p>
        </div>
      </div>
    </div>
    </>
  )
}
